import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { obj } from '../util';

class TableTag extends Component {
  static propTypes = {
    /**
     * 标签类名前缀,提供给二次开发者用
     * @default next-
     */
    prefix: PropTypes.string,
    /**
     * color 标签的颜色，可选值 'red'、'green'、'yellow'、'blue'、'gray'
     */
    color: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any,
  };

  static defaultProps = {
    prefix: 'next-',
    color: 'blue',
  };

  render() {
    const { prefix, color, children, className, rtl, ...others } = this.props;
    const cls = classnames(`${prefix}table-tag`, `${prefix}table-tag-${color}`, className);

    return (
      <span className={cls} {...obj.pickAttrs(others)} dir={rtl ? 'rtl' : undefined}>
        <span className={`${prefix}table-tag-dot`} />
        {children}
      </span>
    );
  }
}

export default TableTag;
